export var IPosition;

(function (IPosition) {
  IPosition["BOTTOM"] = "bottom";
  IPosition["TOP"] = "top";
})(IPosition || (IPosition = {}));